export const LOAD_PROJECT_CATEGORIES = "LOAD_PROJECT_CATEGORIES"
export const LOAD_PROJECT_CATEGORY = "LOAD_PROJECT_CATEGORY"
export const LOAD_PROJECT_CATEGORIES_GROUP = "LOAD_PROJECT_CATEGORIES_GROUP"

